function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { bool, node, shape, string, func } from "prop-types";
import { components } from "react-select";
import classNamesMaker from "classnames";
import { Icon } from "#library/components/Icon/Icon";
import styles from "./ValueContainer.module.css";
var ValueContainer = components.ValueContainer;
export var ValueContainerMulti = function ValueContainerMulti(props) {
  var _classNamesMaker;
  var children = props.children,
    getValue = props.getValue,
    hasValue = props.hasValue,
    isFocused = props.isFocused,
    _props$selectProps = props.selectProps,
    value = _props$selectProps.value,
    placeholder = _props$selectProps.placeholder,
    isDisabled = _props$selectProps.isDisabled,
    isSearchable = _props$selectProps.isSearchable,
    displayValueOnSingleSelection = _props$selectProps.displayValueOnSingleSelection,
    leftIconId = _props$selectProps.leftIconId;
  var numberSelected = getValue().length;
  var hasSingleSelection = numberSelected === 1;
  var childrenArray = React.Children.toArray(children);
  var inputComponent = childrenArray.filter(function (child) {
    return child.type.name === "Input";
  })[0];
  var classNames = classNamesMaker(styles["jds-ValueContainer"], (_classNamesMaker = {}, _defineProperty(_classNamesMaker, styles["jds-ValueContainer--withIcon"], leftIconId), _defineProperty(_classNamesMaker, styles["jds-ValueContainer--isDisabled"], isDisabled), _defineProperty(_classNamesMaker, styles["jds-ValueContainer--isEmpty"], !hasValue), _defineProperty(_classNamesMaker, styles["jds-ValueContainer--isFocused"], isFocused), _defineProperty(_classNamesMaker, styles["jds-ValueContainer--isNotSearchable"], !isSearchable), _classNamesMaker));
  var placeholderValue = placeholder;
  if (hasValue && !isFocused && displayValueOnSingleSelection && hasSingleSelection) placeholderValue = value[0].label;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(ValueContainer, _extends({}, props, {
      className: classNames
    }), leftIconId && /*#__PURE__*/React.createElement(Icon, {
      xlinkHref: "#".concat(leftIconId)
    }), /*#__PURE__*/React.createElement("span", {
      className: styles["jds-ValueContainer__displayedValue"],
      "data-placeholder": placeholderValue
    }, isSearchable ? inputComponent : children))
  );
};
ValueContainerMulti.propTypes = {
  children: node.isRequired,
  getValue: func.isRequired,
  hasValue: bool.isRequired,
  isFocused: bool.isRequired,
  selectProps: shape({
    placeholder: string,
    isDisabled: bool
  }).isRequired
};